import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

/**
 * Utility function to handle consistent "back to projects" navigation
 * Always navigates to home page and scrolls to selected work section
 */
export const navigateToSelectedWork = (router: AppRouterInstance) => {
  // Navigate to home page
  router.push("/");
  
  // Wait for navigation to complete, then scroll to selected work section
  setTimeout(() => {
    const selectedWorkSection = document.getElementById("selected-work-section");
    if (selectedWorkSection) {
      selectedWorkSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, 150);
};

/**
 * Utility function to handle consistent "back to about" navigation  
 * Always navigates to home page and scrolls to about section
 */
export const navigateToAboutSection = (router: AppRouterInstance) => {
  // Navigate to home page
  router.push("/");
  
  // Wait for navigation to complete, then scroll to about section
  setTimeout(() => {
    const aboutSection = document.getElementById("amilcar-teixeira-section");
    if (aboutSection) {
      aboutSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, 150);
};

/**
 * Generic function to scroll to a section on the current page
 */
export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};